<template>
  <div class="altitude-danger-row row align-items-center">
    <div class="col-6 col-lg-3 col-print-3 pr-0">
      <div class="row align-items-center">
        <div class="col-12 col-lg-6 col-print-6 flex-lg-last mb-2 altitude-danger-row__icon">
          <RiskIcon :rating="rating" />
        </div>
        <div class="col-12 col-lg-6 col-print-6">
          <h3 class="altitude-danger-row__heading">{{ niceLevel }}</h3>
          <p v-if="niceAltitude" class="altitude-danger-row__altitude">{{ niceAltitude }}</p>
        </div>
      </div>
    </div>
    <div class="col-6 col-lg-3 col-print-3 pl-0 text-center">
      <Indicator v-bind="indicatorProps" />
    </div>
    <div class="col-12 col-lg-6 col-print-6">
      <RiskPill :rating="rating" />
      <p class="mb-0">{{ description }}</p>
    </div>
  </div>
</template>

<script>
  import constants from '../../constants';
  import Indicator from '../altitude-danger-indicator/AltitudeDangerIndicator';
  import RiskIcon from '../risk-icon/RiskIcon';
  import RiskPill from '../risk-pill/RiskPill';

  export default {
    components: {
      Indicator,
      RiskIcon,
      RiskPill,
    },

    props: {
      level: {
        type: Number,
        required: true,
      },

      rating: {
        type: Number,
        default: 0,
      },

      altitudeTo: {
        type: Number,
      },

      altitudeFrom: {
        type: Number,
      },
    },

    computed: {
      niceLevel() {
        let level;

        switch (this.level) {
          case 0:
            level = 'High Alpine';
            break;
          case 1:
            level = 'Alpine';
            break;
          default:
            level = 'Sub Alpine';
        }

        return level;
      },

      niceAltitude() {
        let altitude;

        if (!this.altitudeFrom) {
          return '';
        }

        switch (this.level) {
          case 0:
            altitude = `Above ${this.altitudeFrom} metres`;
            break;
          case 1:
            altitude = `${this.altitudeTo} - ${this.altitudeFrom} metres`;
            break;
          default:
            altitude = `Below ${this.altitudeFrom} metres`;
        }

        return altitude;
      },

      description() {
        return constants.TRAVEL_ADVICE[this.rating];
      },

      indicatorProps() {
        let prop;

        switch (this.level) {
          case 0:
            prop = 'highRating';
            break;
          case 1:
            prop = 'midRating';
            break;
          default:
            prop = 'lowRating';
        }

        return { [prop]: this.rating };
      },
    },
  };
</script>
